module.exports = __webpack_public_path__ + "public/images/program/program-13.57acdc54b14001fec938f286022426ee.jpg";